import * as React from 'react';
import cx from 'clsx';

import { QuicksilverTileOutfitType } from '../types';

import styles from './SashLayer.module.scss';

interface SashLayerProps {
  sash: string;
  background: string;
  outfit: QuicksilverTileOutfitType;
}

const SashLayer = ({ sash, background, outfit }: SashLayerProps) => (
  <div
    className={cx(
      styles.container,
      outfit === 'small' && styles.containerSmall
    )}
    style={{ background: background }}
    data-testid="sash-wrapper"
  >
    <span
      className={cx(styles.text, outfit === 'small' && styles.textSmall)}
      data-testid="sash-text"
    >
      {sash}
    </span>
  </div>
);

export default SashLayer;
